import { useState } from 'react';
import { SystemIcon } from '@monorepo/nova-icons';
import { IconButton, Popover, useTheme } from '@monorepo/nova-ui';
import { CartData } from '@monorepo/types';
import { getActiveAssets } from '../../../libs/const/cart-items';
import { getFilteredActiveAssets } from '../../../utils';
import { CartPopover } from '../../cart/cart-popover';
import { StyledCartBadge } from './styles/cart-button.styled';

interface CartButtonProps {
  cartData: CartData;
}

export const CartButton = ({ cartData }: CartButtonProps) => {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const { palette, spacing } = useTheme();
  const { cart, project } = cartData;
  const activeAssets = cart ? getActiveAssets(cart) : [];
  const filteredActiveAssets = project
    ? getFilteredActiveAssets(activeAssets, project)
    : [];
  const hasCartItems = filteredActiveAssets.length > 0;

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setIsCartOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIsCartOpen(false);
  };
  return (
    <>
      <IconButton onClick={handleOpen} aria-label="Cart" sx={{ p: 1.25 }}>
        <SystemIcon
          iconName="ShoppingCartSimple"
          color={isCartOpen ? 'primary' : undefined}
          sx={{
            position: 'relative',
            width: spacing(7.25),
            height: spacing(7.25),
          }}
        />
        {hasCartItems && <StyledCartBadge />}
      </IconButton>
      <Popover
        open={isCartOpen}
        anchorEl={anchorEl as HTMLElement}
        onClose={handleClose}
        disableScrollLock
        variant="mobile-centered"
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        slotProps={{
          paper: {
            sx: {
              width: '346px',
              marginTop: '12px',
              padding: '16px',
              maxHeight: '80vh',
              backgroundColor: palette.background.contrast,
              backgroundImage: 'none',
              borderRadius: '40px',
              boxShadow: '0 4px 24px 0 rgba(0, 0, 0, 0.10)',
              border: `1px solid ${palette.info.main}`,
            },
          },
        }}
      >
        <CartPopover handleClose={handleClose} cartData={cartData} />
      </Popover>
    </>
  );
};
